import {CountryCodeElement} from "./NationalityElement";

export function CountryElement({countryCode, asPrint = false, shape = "round"}: {
    countryCode: string | undefined;
    asPrint?: boolean;
    shape?: "round" | "flag";
}) {
    return <CountryCodeElement countryCode={countryCode} asPrint={asPrint} shape={shape}/>;
}
